import { Component } from '@verndale/core';
import '../../scss/components/_search-field.scss';

class Search extends Component {
  setupDefaults() {
    this.dom = {
      triggers: this.el.querySelectorAll('.search-field__item-trigger'),
      input: this.el.querySelector('.base-input input') as HTMLInputElement
    };

    this.initSearchField();
  }

  addListeners() {
    (this.dom.triggers as NodeList).forEach(trigger =>
      trigger.addEventListener('click', this.handleClick.bind(this))
    );

    (this.dom.input as HTMLInputElement).addEventListener('keyup', this.handleKeyPress.bind(this));
  }

  initSearchField() {
    if (this.el.classList.contains('is-animated')) {
      this.setAriaExpanded('false');
    }
  }

  setAriaExpanded(state: string) {
    (this.dom.triggers as NodeListOf<HTMLButtonElement>).forEach(trigger => {
      trigger.setAttribute('aria-expanded', state);
    });
  }

  handleClick(e: Event) {
    const trigger = e.currentTarget as HTMLButtonElement;
    const isAnimated = this.el.classList.contains('is-animated');

    if (trigger.classList.contains('search')) {
      if (isAnimated) {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          this.triggerSearch();
        } else {
          this.expandSearchField();
        }
      } else {
        this.triggerSearch();
      }
    } else {
      this.closeItem();
    }
  }

  handleKeyPress(e: KeyboardEvent) {
    const input = this.el.querySelector('.base-input input') as HTMLInputElement;
    if (input.value.length > 2) {
      if (e.key === 'Enter') {
        this.triggerSearch();
      }
    }
  }

  expandSearchField() {
    this.setAriaExpanded('true');
    this.el.classList.add('is-expanded');
  }

  closeItem() {
    this.setAriaExpanded('false');
    this.el.classList.remove('is-expanded');
  }

  triggerSearch() {
    const input = this.el.querySelector('.base-input input') as HTMLInputElement;
    const url = this.el.dataset.searchUrl || 'search';

    if (input.value.length > 2) {
      location.href = `${location.origin}${url}${input.value}`;
    }
  }
}

export default Search;
